import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  errorHeaderClass: {
    textAlign: 'left',
  },
}));
